module.exports = __webpack_public_path__ + "img/cooperative0_logo1.cb9c564f.jpg";